import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3 sm:grid-cols-1" }
const _hoisted_2 = { class: "grid grid-cols-2 gap-3" }

import { InputRow, Select, DatePicker } from '@/components/ui/form';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'VatDeadlineForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "period",
      label: "system.vat_deadlines_header"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Select), {
          modelValue: _ctx.form.period,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.period) = $event)),
          options: [
                    { value: 'monthly', label: 'companies.vat_frequency_options.monthly' },
                    { value: 'quarterly', label: 'companies.vat_frequency_options.quarterly' },
                    { value: 'six-monthly', label: 'companies.vat_frequency_options.six-monthly' },
                ],
          translate: true
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["form"]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "settlement_period_from",
        label: "system.settlement_period_from"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DatePicker), {
            modelValue: _ctx.form.settlement_period_from,
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.settlement_period_from) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["form"]),
      _createVNode(_unref(InputRow), {
        form: _ctx.form,
        name: "settlement_period_to",
        label: "system.settlement_period_to"
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(DatePicker), {
            modelValue: _ctx.form.settlement_period_to,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.settlement_period_to) = $event))
          }, null, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["form"])
    ]),
    _createVNode(_unref(InputRow), {
      form: _ctx.form,
      name: "deadline",
      label: "system.vat_deadlines.deadline"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(DatePicker), {
          modelValue: _ctx.form.deadline,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.deadline) = $event))
        }, null, 8, ["modelValue"])
      ]),
      _: 1
    }, 8, ["form"])
  ]))
}
}

})